// extracted by mini-css-extract-plugin
module.exports = {"header_border":"model_header_border__110P0","header_bg":"model_header_bg__1wRIa"};